import React, { Component } from "react";
import { Col, Card, Form } from "antd";
import moment from "moment-timezone";

const FormItem = Form.Item;

class AuditTrail extends Component {
  render() {
    const { rawData } = this.props;

    return rawData && ["New", "Waiting"].includes(rawData.status) ? null : (
      <Col className="gutter-row" span={8} style={{ marginTop: 35 }}>
        <Card title="Audit Trail">
          <div>
            <h4>Tanggal Pengajuan Diskon</h4>
            <h4 style={{ fontWeight: "normal" }}>
              {rawData && rawData.createdAt
                ? moment(rawData.createdAt).format("DD/MM/YYYY (HH:mm:ss)")
                : "-"}
            </h4>
          </div>
          {rawData && rawData.status === "Reject" ? (
            <div>
              <h4>Tanggal Penolakan Diskon</h4>
              <h4 style={{ fontWeight: "normal" }}>
                {rawData && rawData.rejectedAt
                  ? moment(rawData.rejectedAt).format("DD/MM/YYYY (HH:mm:ss)")
                  : "-"}
              </h4>
            </div>
          ) : null}
          {rawData && rawData.status === "Cancel" ? (
            <div>
              <h4>Tanggal Pembatalan Diskon</h4>
              <h4 style={{ fontWeight: "normal" }}>
                {rawData && rawData.cancelledAt
                  ? moment(rawData.cancelledAt).format("DD/MM/YYYY (HH:mm:ss)")
                  : "-"}
              </h4>
            </div>
          ) : null}
          {(rawData && rawData.status.includes("SPK")) ||
          (rawData && rawData.status === "Done") ? (
            <div>
              <h4>Tanggal Approve Diskon</h4>
              <h4 style={{ fontWeight: "normal" }}>
                {rawData && rawData.completionAt
                  ? moment(rawData.completionAt).format("DD/MM/YYYY (HH:mm:ss)")
                  : "-"}
              </h4>
            </div>
          ) : null}
          {(rawData && rawData.status.includes("SPK")) ||
          (rawData && rawData.status === "Done") ? (
            <div>
              <h4>Tanggal Pembuatan SPK</h4>
              <h4 style={{ fontWeight: "normal" }}>
                {rawData && rawData.spkRequestAt
                  ? moment(rawData.spkRequestAt).format("DD/MM/YYYY (HH:mm:ss)")
                  : "-"}
              </h4>
            </div>
          ) : null}
          {rawData && rawData.status === "SPK Reject" ? (
            <div>
              <h4>Tanggal Penolakan SPK</h4>
              <h4 style={{ fontWeight: "normal" }}>
                {rawData && rawData.spkRejectedAt
                  ? moment(rawData.spkRejectedAt).format(
                      "DD/MM/YYYY (HH:mm:ss)"
                    )
                  : "-"}
              </h4>
            </div>
          ) : null}
          {rawData && rawData.status === "Done" ? (
            <div>
              <h4>Tanggal Approve SPK</h4>
              <h4 style={{ fontWeight: "normal" }}>
                {rawData && rawData.spkApprovedAt
                  ? moment(rawData.spkApprovedAt).format(
                      "DD/MM/YYYY (HH:mm:ss)"
                    )
                  : "-"}
              </h4>
            </div>
          ) : null}
        </Card>
      </Col>
    );
  }
}

export default AuditTrail;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Section/AuditTrail.js